"use client";

import Box from "@mui/material/Box"; // GLOBAL CUSTOM COMPONENTS
import SectionCreator from "./footmart/section-creator";
import { CAROUSEL_ARROW_STYLE } from "src/lib/components/category-section/footmart/styles";
import { Carousel } from "../salify-next-layout/default/components/carousel";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import React, { useEffect, useState } from "react";
import { Product } from "src/lib/fetcher/client";
import { useMediaQuery, useTheme } from "@mui/material";
import clsx from "clsx";
import CategoryItemVertical from "src/lib/components/category-item/vertical";

// =========================================================

export interface VariantProps {
  title: string;
  subTitle?: string;
  featuredOption?: string;
}
const CategoriesListSection: React.FC<VariantProps> = ({ title, subTitle, featuredOption }) => {
  const categories = SalifyFallback.useSelect<Product[]>("output:categories.data");
  const [isAfterInit, setIsAfterInit] = useState(false);
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery("(max-width:767px)");
  const responsive = [
    {
      breakpoint: breakpoints.values.md,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: breakpoints.values.sm,
      settings: {
        slidesToShow: 1.25,
        centerMode: true,
      },
    },
  ];
  const cls = clsx({
    "on-init": !isAfterInit,
  });
  const [slideToShow, setSlideToShow] = useState(1);
  useEffect(() => {
    if (!isMobile) {
      setSlideToShow(4);
    }
  }, [isMobile]);
  return (
    <SectionCreator
      style={{
        margin: "20px",
      }}
      title={title}
      subTitle={subTitle}
      seeMoreLink="/collection"
      bgColor={isMobile ? "inherit" : "white"}
    >
      <div className={cls}>
        <Carousel
          dotColor={undefined}
          slidesToShow={slideToShow}
          initialSlide={0}
          responsive={responsive}
          arrowStyles={CAROUSEL_ARROW_STYLE}
          onInit={() => {
            setIsAfterInit(true);
          }}
        >
          {categories.map((item, index) => (
            <Box pb={2} key={index} sx={{ height: "inherit" }}>
              <CategoryItemVertical {...item} highlightPrice featuredOption={featuredOption} />
            </Box>
          ))}
        </Carousel>
      </div>
    </SectionCreator>
  );
};

export default CategoriesListSection;
